export default __webpack_public_path__ + "static/media/hinge.917dc5cc.jfif";